<div class="manager-shell">
  <section class="manager-hero card-glass">
    <div class="hero-copy">
      <p class="eyebrow">Spay · Gestionnaire</p>
      <h1>Espace de navigation gestionnaire</h1>
      <p class="lead">
        Accedez rapidement aux flux membres, comptes personnels et comptes pro depuis un point unique.
      </p>
    </div>

    <div class="hero-kpis">
      <article class="kpi-card">
        <p class="kpi-label">Actions disponibles</p>
        <p class="kpi-value">{{ navigationActions.length }}</p>
        <p class="kpi-hint">Raccourcis metier</p>
      </article>
      <article class="kpi-card">
        <p class="kpi-label">Utilisateurs geres</p>
        <p class="kpi-value">{{ managedUsersCount }}</p>
        <p class="kpi-hint">Membres rattaches</p>
      </article>
    </div>
  </section>

  <section class="manager-actions card-glass">
    <div class="section-head">
      <h2>Navigation principale</h2>
      <small>Acces direct aux ecrans que vous utilisez le plus.</small>
    </div>

    <div class="action-grid">
      <a
        *ngFor="let action of navigationActions; trackBy: trackAction"
        [routerLink]="action.route"
        class="action-card"
        [class.action-primary]="action.tone === 'primary'"
        [class.action-secondary]="action.tone === 'secondary'"
        [class.action-light]="action.tone === 'light'"
      >
        <div class="action-icon">
          <i [class]="action.icon"></i>
        </div>
        <div class="action-content">
          <h3>{{ action.label }}</h3>
          <p>{{ action.description }}</p>
        </div>
      </a>
    </div>
  </section>

  <section class="manager-users card-glass">
    <div class="section-head section-head-inline">
      <div>
        <h2>Utilisateurs sous supervision</h2>
        <small>Liste des utilisateurs lies a votre profil gestionnaire.</small>
      </div>

      <button type="button" class="btn btn-sm btn-outline-light" (click)="getUserliste()" [disabled]="loadingUsers">
        Actualiser
      </button>
    </div>

    <div class="status-line" *ngIf="loadingUsers">Chargement des utilisateurs...</div>

    <div class="alert alert-danger py-2" *ngIf="!loadingUsers && loadUsersError">
      {{ loadUsersError }}
    </div>

    <div class="empty-state" *ngIf="!loadingUsers && !loadUsersError && persons.length === 0">
      Aucun utilisateur rattache pour le moment.
    </div>

    <div class="table-responsive" *ngIf="!loadingUsers && !loadUsersError && persons.length > 0">
      <table class="table table-hover table-borderless align-middle mb-0 manager-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nom</th>
            <th>Prenom</th>
            <th>Telephone</th>
            <th>Email</th>
            <th class="text-end">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let person of persons; trackBy: trackUser">
            <td>{{ person.id }}</td>
            <td>{{ person.lastName }}</td>
            <td>{{ person.firstName }}</td>
            <td>{{ person.phone }}</td>
            <td>{{ person.email || '-' }}</td>
            <td class="text-end">
              <div class="row-actions">
                <button type="button" class="btn btn-sm btn-outline-info" (click)="openPersonalAccount(person.id)">
                  Compte perso
                </button>

                <button
                  *ngIf="hasBusinessAccount(person)"
                  type="button"
                  class="btn btn-sm btn-outline-warning"
                  (click)="openBusinessAccount(person.id)"
                >
                  Compte business
                </button>

                <span *ngIf="!hasBusinessAccount(person)" class="badge text-bg-secondary">Sans business</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>
